import type { Kks } from "@shared/types/domain";
import { useMemo, useState } from "react";

export function useKksFilters(sorted: Kks[]) {
  const [filterRegex, setFilterRegex] = useState("");
  const [filterRequired, setFilterRequired] = useState<boolean | null>(null);
  const [filterVerified, setFilterVerified] = useState<boolean | null>(null);
  const [filterSpof, setFilterSpof] = useState<boolean | null>(null);
  const [filterSpofApproved, setFilterSpofApproved] = useState<boolean | null>(
    null,
  );
  const [filterRequiredSpof, setFilterRequiredSpof] = useState<boolean | null>(
    null,
  );
  const [filterComponentSet, setFilterComponentSet] = useState<boolean | null>(
    null,
  );

  const filterRe = useMemo(() => {
    if (!filterRegex) return null;
    try {
      return new RegExp(filterRegex, "i");
    } catch {
      return null;
    }
  }, [filterRegex]);

  const hasActiveFilter =
    filterRegex !== "" ||
    filterRequired !== null ||
    filterVerified !== null ||
    filterSpof !== null ||
    filterSpofApproved !== null ||
    filterRequiredSpof !== null ||
    filterComponentSet !== null;

  const filteredIndices = useMemo(() => {
    if (!hasActiveFilter) return null;
    if (filterRegex !== "" && filterRe === null) return [];
    const indices: number[] = [];
    sorted.forEach((item, idx) => {
      if (filterRe && !filterRe.test(item.text)) return;
      if (filterRequired !== null && item.required !== filterRequired) return;
      if (filterVerified !== null && item.verified !== filterVerified) return;
      if (filterSpof !== null && item.spof !== filterSpof) return;
      if (
        filterSpofApproved !== null &&
        item.spof_approved !== filterSpofApproved
      )
        return;
      if (
        filterRequiredSpof !== null &&
        !!item.required_spof !== filterRequiredSpof
      )
        return;
      if (
        filterComponentSet !== null &&
        (item.component !== "Unknown") !== filterComponentSet
      )
        return;
      indices.push(idx);
    });
    return indices;
  }, [
    sorted,
    filterRe,
    filterRegex,
    hasActiveFilter,
    filterRequired,
    filterVerified,
    filterSpof,
    filterSpofApproved,
    filterRequiredSpof,
    filterComponentSet,
  ]);

  return {
    filterRegex,
    setFilterRegex,
    filterRequired,
    setFilterRequired,
    filterVerified,
    setFilterVerified,
    filterSpof,
    setFilterSpof,
    filterSpofApproved,
    setFilterSpofApproved,
    filterRequiredSpof,
    setFilterRequiredSpof,
    filterComponentSet,
    setFilterComponentSet,
    filterRe,
    hasActiveFilter,
    filteredIndices,
  };
}
